import {Injectable} from '@angular/core';
import {LabelExpressionUtilityService} from '../label-expression-utility-service';
import {LabelExpressionBuildService} from './label-expression-build.service';
import {labelProperties, SubTypeMap, Attributes} from '../../../../common/models/label-expression.model';

@Injectable({
    providedIn: 'root'
})
export class EnlargementLabelExpressionBuilderService {
    title = 'EnlargementLabelExpressionBuilder';
    subTypeMap: SubTypeMap = [];

    constructor(
        private labelExpressionBuildService: LabelExpressionBuildService,
        private labelExpressionUtilityService: LabelExpressionUtilityService
    ) {
        this.init();
    }

    private init() {
        this.subTypeMap[1] = {function: this.buildEnlargementAnnotation.bind(this)};
    }

    build(attributes: Attributes) {
        return this.labelExpressionBuildService.build(this.title, this.subTypeMap, attributes);
    }

    buildEnlargementAnnotation(attributes: Attributes) {
        let labels = [];
        let labelProperties = {} as labelProperties;
        labels.push(this.labelExpressionUtilityService.getLabelProperties('10em', 'normal', 'middle', attributes.attribute1.toUpperCase()));

        labelProperties.labels = labels;
        labelProperties.labelExpression = this.labelExpressionUtilityService.formatLabel(attributes.attribute1.toUpperCase(), 10, true);

        return attributes.attribute1 ? labelProperties : null;
    }
}
